export const EMPLOYER_PROVIDED = "employer_provided";
export const RENTAL_OR_PUBLIC = "rental_or_public";

export const MOCK_HOUSING_SITE = {
    sid: "sample-housing-site",
    name: "Sample Housing Site",
    housing_type: EMPLOYER_PROVIDED,
    current_occupancy: 24,
    total_occupancy: 30,
    physical_address: "123 Sample Rd",
    physical_city: "Yakima",
    physical_state: "WA",
    physical_zipcode: "98901",
    lat: 46.6021,
    lng: -120.5059,
};
